import { useEffect, useMemo, useRef, useState } from "react";
import { isEqual } from "lodash";

export function useFancyUpdater({
  data,
  type,
  favouriteList,
  fancyHeaderKey,
  headerFilters,
  reorderArray,
}) {
  const [updatedArray, setUpdatedArray] = useState([]);
  const prevData = useRef();

  const normalize = (str = "") => str.toLowerCase();

  const fancyNewUpdate = useMemo(() => {
    if (!data?.length) return [];
    if (type === "fancyPlus") {
      return data.filter(({ name = "", categoryType }) => {
        const normalized = normalize(name);
        return (
          /lambi/.test(normalized) ||
          normalized.includes("@1") ||
          categoryType === 6 ||
          normalized.includes("odd run bhav") ||
          normalized.includes("top")
        );
      });
    }
    return data;
  }, [data, type]);
  const baseArray = useMemo(() => {
    if (favouriteList?.length > 0) {
      return reorderArray(favouriteList, fancyNewUpdate);
    }
    return fancyNewUpdate;
  }, [favouriteList, fancyNewUpdate]);

  const filteredBaseArray = useMemo(() => {
    if (type === "fancy") {
      return baseArray.filter(({ name = "", categoryType }) => {
        const normalized = normalize(name);
        return (
          !normalized.includes("odd run bhav") &&
          categoryType !== 6 &&
          !normalized.includes("top")
        );
      });
    }
    return baseArray;
  }, [baseArray, type]);

  const newData = useMemo(() => {
    if (fancyHeaderKey === "All") return filteredBaseArray;
    if (fancyHeaderKey === "extra")
      return filteredBaseArray.filter((item) =>
        normalize(item?.name).includes("adv")
      );
    if (headerFilters?.[fancyHeaderKey]) {
      const keywords = headerFilters[fancyHeaderKey];
      return filteredBaseArray.filter(({ name = "" }) =>
        keywords.some((word) => normalize(name).includes(word))
      );
    }
    return filteredBaseArray.filter(
      (res) => res?.categoryType == fancyHeaderKey
    );
  }, [filteredBaseArray, fancyHeaderKey, headerFilters]);


  useEffect(() => {
    if (!isEqual(prevData.current, newData)) {
      prevData.current = newData;
      setUpdatedArray(newData);
    }
  }, [newData]);

  return updatedArray;
}
